import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {EventsStoredObjects} from "../../@types/response";

export const getFixtures = (state: ReducerFromState<CommonReducer>): EventsStoredObjects => state.common.fixtures;